RivalIQ.apps.SocialChannelMatrix.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const EmptyView = Marionette.ItemView.mixin({
        tagName: 'tr',
        template: '#emptyMatrixListTemplate',
        serializeData: function () {
            const me = this;
            return {
                colspan: 2 + _.size(me.getOption('channels'))
            };
        }
    });

    views.MatrixList = RivalIQ.views.CompositeView.mixin({
        template: '#matrixListTemplate',
        className: 'social-channel-matrix',
        emptyView: EmptyView,
        childViewContainer: 'tbody',
        childView: views.MatrixListRow,

        ui: {
            facebookCheckbox: '.facebook-checkbox',
            instagramCheckbox: '.instagram-checkbox',
            twitterCheckbox: '.twitter-checkbox',
            youtubeCheckbox: '.youtube-checkbox',
            tiktokCheckbox: '.tiktok-checkbox',
            facebookLogo: '.fa-facebook',
            instagramLogo: '.fa-instagram',
            twitterLogo: '.fa-twitter',
            youtubeLogo: '.fa-youtube-play',
            tiktokLogo: '.fa-tiktok',
            tooltips: '[data-toggle="tooltip"]'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            companySets: RivalIQ.apps.Shell.mixins.CompanySetEventsMixin
        },

        eventsNotToDebounce: {
            'click @ui.facebookCheckbox': 'facebookCheckboxClicked',
            'click @ui.instagramCheckbox': 'instagramCheckboxClicked',
            'click @ui.twitterCheckbox': 'twitterCheckboxClicked',
            'click @ui.youtubeCheckbox': 'youtubeCheckboxClicked',
            'click @ui.tiktokCheckbox': 'tiktokCheckboxClicked'
        },

        dashboardModelEvents: {
            'change:companySetDescriptor': 'reload',
            'change:focusCompanyId': 'reload'
        },

        companySetEvents: {
            'companySetsChanged': 'reload'
        },

        childEvents: {
            'unfollowed': 'onItemUnfollowed'
        },


        onRender: function () {
            const me = this;
            me.setSocialChannelMatrixState();
            me.ui.tooltips.tooltip({
                container: 'body',
                delay: {
                    show: 500,
                    hide: 100
                }
            });
        },

        setSocialChannelMatrixState: function () {
            const me = this;
            const sourceMask = RivalIQ.enums.sourceMask;

            const facebookChannelAccess = RivalIQ.state.landscape.channelAccess(sourceMask.FACEBOOK);
            me.ui.facebookCheckbox.prop('checked', facebookChannelAccess);
            me.toggleChannel([sourceMask.FACEBOOK, sourceMask.FACEBOOK_INSIGHTS, sourceMask.FACEBOOK_ADS, sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS], facebookChannelAccess);
            me.toggleLogoColor(me.ui.facebookLogo, facebookChannelAccess);
            me.disableCell(document.getElementsByClassName('x-has-facebook cell-middle'), !facebookChannelAccess);

            const instagramChannelAccess = RivalIQ.state.landscape.channelAccess(sourceMask.INSTAGRAM);
            me.ui.instagramCheckbox.prop('checked', instagramChannelAccess);
            me.toggleChannel([sourceMask.INSTAGRAM, sourceMask.INSTAGRAM_INSIGHTS], instagramChannelAccess);
            me.toggleLogoColor(me.ui.instagramLogo, instagramChannelAccess);
            me.disableCell(document.getElementsByClassName('x-has-instagram cell-middle'), !instagramChannelAccess);

            const twitterChannelAccess = RivalIQ.state.landscape.channelAccess(sourceMask.TWITTER);
            me.ui.twitterCheckbox.prop('checked', twitterChannelAccess);
            me.toggleChannel([sourceMask.TWITTER, sourceMask.TWITTER_INSIGHTS], twitterChannelAccess);
            me.toggleLogoColor(me.ui.twitterLogo, twitterChannelAccess);
            me.disableCell(document.getElementsByClassName('x-has-twitter cell-middle'), !twitterChannelAccess);

            const youtubeChannelAccess = RivalIQ.state.landscape.channelAccess(sourceMask.YOUTUBE);
            me.ui.youtubeCheckbox.prop('checked', youtubeChannelAccess);
            me.toggleChannel([sourceMask.YOUTUBE], youtubeChannelAccess);
            me.toggleLogoColor(me.ui.youtubeLogo, youtubeChannelAccess);
            me.disableCell(document.getElementsByClassName('x-has-youtube cell-middle'), !youtubeChannelAccess);

            const tiktokChannelAccess = RivalIQ.state.landscape.channelAccess(sourceMask.TIKTOK);
            me.ui.tiktokCheckbox.prop('checked', tiktokChannelAccess);
            me.toggleChannel([sourceMask.TIKTOK], tiktokChannelAccess);
            me.toggleLogoColor(me.ui.tiktokLogo, tiktokChannelAccess);
            me.disableCell(document.getElementsByClassName('x-has-tiktok cell-middle'), !tiktokChannelAccess);

            let numAccessibleChannels = 0;
            facebookChannelAccess ? numAccessibleChannels += 1 : null;
            instagramChannelAccess ? numAccessibleChannels += 1 : null;
            twitterChannelAccess ? numAccessibleChannels += 1 : null;
            youtubeChannelAccess ? numAccessibleChannels += 1 : null;
            tiktokChannelAccess ? numAccessibleChannels += 1 : null;

            if (numAccessibleChannels === 1) {
                me.ui.facebookCheckbox.prop('disabled', RivalIQ.state.landscape.channelAccess(sourceMask.FACEBOOK));
                me.ui.instagramCheckbox.prop('disabled', RivalIQ.state.landscape.channelAccess(sourceMask.INSTAGRAM));
                me.ui.twitterCheckbox.prop('disabled', RivalIQ.state.landscape.channelAccess(sourceMask.TWITTER));
                me.ui.youtubeCheckbox.prop('disabled', RivalIQ.state.landscape.channelAccess(sourceMask.YOUTUBE));
                me.ui.tiktokCheckbox.prop('disabled', RivalIQ.state.landscape.channelAccess(sourceMask.TIKTOK));
            } else {
                me.ui.facebookCheckbox.prop('disabled', false);
                me.ui.instagramCheckbox.prop('disabled', false);
                me.ui.twitterCheckbox.prop('disabled', false);
                me.ui.youtubeCheckbox.prop('disabled', false);
                me.ui.tiktokCheckbox.prop('disabled', false);
            }
        },

        toggleChannel: function (sourceMasks, isCheckboxChecked) {

            for (const sourceMask of sourceMasks) {
                RivalIQ.state.landscape.setActiveSourceMask(sourceMask, isCheckboxChecked);
            }
        },

        toggleLogoColor: function (logo, isEnabled) {
            if (isEnabled) {
                logo.addClass('fa-color').removeClass('fa-disabled');
            } else {
                logo.removeClass('fa-color').addClass('fa-disabled');
            }
        },

        disableCell: function (cells, isDisabled) {
            if (isDisabled) {
                for (const cell of cells) {
                    cell.classList.add('disabled-cell');
                }
            } else {
                for (const cell of cells) {
                    cell.classList.remove('disabled-cell');
                }
            }
        },

        trackToggle: function (isCheckboxChecked) {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ToggledChannelVisibility, {
                visible: isCheckboxChecked
            });
        },

        setStateTrackToggleInvalidateCaches: function (isCheckboxChecked) {
            const me = this;
            me.trackToggle(isCheckboxChecked);
            me.setSocialChannelMatrixState();
            RivalIQ.data.CacheLayer.invalidateAllCaches(true);
        },

        facebookCheckboxClicked: function () {
            const me = this;
            const sourceMask = RivalIQ.enums.sourceMask;
            const isCheckboxChecked = me.ui.facebookCheckbox.is(':checked');
            me.toggleChannel([sourceMask.FACEBOOK, sourceMask.FACEBOOK_INSIGHTS, sourceMask.FACEBOOK_ADS, sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS], isCheckboxChecked);
            me.setStateTrackToggleInvalidateCaches(isCheckboxChecked);
        },

        instagramCheckboxClicked: function () {
            const me = this;
            const sourceMask = RivalIQ.enums.sourceMask;
            const isCheckboxChecked = me.ui.instagramCheckbox.is(':checked');
            me.toggleChannel([sourceMask.INSTAGRAM, sourceMask.INSTAGRAM_INSIGHTS], isCheckboxChecked);
            me.setStateTrackToggleInvalidateCaches(isCheckboxChecked);
        },

        twitterCheckboxClicked: function () {
            const me = this;
            const sourceMask = RivalIQ.enums.sourceMask;
            const isCheckboxChecked = me.ui.twitterCheckbox.is(':checked');
            me.toggleChannel([sourceMask.TWITTER, sourceMask.TWITTER_INSIGHTS], isCheckboxChecked);
            me.setStateTrackToggleInvalidateCaches(isCheckboxChecked);
        },

        youtubeCheckboxClicked: function () {
            const me = this;
            const sourceMask = RivalIQ.enums.sourceMask;
            const isCheckboxChecked = me.ui.youtubeCheckbox.is(':checked');
            me.toggleChannel([sourceMask.YOUTUBE], isCheckboxChecked);
            me.setStateTrackToggleInvalidateCaches(isCheckboxChecked);
        },

        tiktokCheckboxClicked: function () {
            const me = this;
            const sourceMask = RivalIQ.enums.sourceMask;
            const isCheckboxChecked = me.ui.tiktokCheckbox.is(':checked');
            me.toggleChannel([sourceMask.TIKTOK], isCheckboxChecked);
            me.setStateTrackToggleInvalidateCaches(isCheckboxChecked);
        },

        filter: function (model) {
            const me = this;

            const companySetDescriptor = me.getProp('companySetDescriptor');
            return model.hasCompanySet(companySetDescriptor, me.getProp('focusCompanyId'));
        },

        loadData: function () {
            const me = this;

            // NOTE we use the global instance of companyData here to ensure
            // that we are never out of sync when adding companies
            // TODO make this flow better
            const companyData = RivalIQ.state.landscape.get('companies');
            const deferred = new $.Deferred();

            const focusCompanyId = _.get(companyData.at(0), 'id');
            if (focusCompanyId !== me.getProp('focusCompanyId')) {
                _.defer(function () {
                    // TODO this is ludicrously slow
                    companyData.sort();
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }

            me.collection = companyData;

            return deferred;
        },

        serializeData: function () {
            const me = this;

            const data = _.defaults({
                sources: RivalIQ.enums.sourceMask,
                channelAccess: function (channel) {
                    return RivalIQ.state.landscape.channelAccess(channel);
                },
                channelSupported: function (channel) {
                    return RivalIQ.state.account.channelSupported(channel);
                },
                noCheckboxes: me.getOption('noCheckboxes')
            }, (me.model ? me.model.toJSON() : null));

            return data;
        },

        _getChannels: function () {
            return _.filter(App.enums.Channel, function (channel) {
                return RivalIQ.state.account.channelSupported(channel.source);
            });
        },

        childViewOptions: function (model) {
            const me = this;
            const modelId = model.get('id');

            const result = {
                companyData: me.collection,
                channels: me._getChannels(),
                dashboardModel: me.dashboardModel,
                isFocusCompany: RivalIQ.state.utils.isFocusedCompany(modelId),
                hideActions: me.getOption('hideActions'),
                showRemoveAction: me.getOption('showRemoveAction'),
                is1xux: me.getOption('is1xux')
            };

            return result;
        },

        emptyViewOptions: function () {
            const me = this;
            return {
                channels: me._getChannels()
            };
        },

        onRenderLoaded: function () {
            const me = this;
            me.initializePopovers();

            // NOTE use filtered size
            const length = me.children.length;
            if (length <= 6) {
                me.$el.addClass('matrix-large');
            } else if (length <= 10) {
                me.$el.addClass('matrix-normal');
            } else {
                me.$el.addClass('matrix-small');
            }
            me.setSocialChannelMatrixState();
        },

        initializePopovers: function () {
            const me = this;

            me.$('[data-toggle="popover"]').popover({
                html: true,
                placement: 'auto top'
            });
        },

        onItemUnfollowed: function (view) {
            const me = this;
            const model = view.model;
            const id = model.id;
            const collection = me.collection;

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.CompanyRemoveFromLandscape);
            RivalIQ.execute('landscape:company:remove', id, function (error, data) {
                if (error || data === null) {

                    RivalIQ.execute('alert:danger', 'We failed to remove a company from your landscape, please try again.');
                    return;
                }

                collection.remove(model);
            });
        }
    });

});
